import gql from "graphql-tag";

export interface CampaignTypeAPost {
  id: string;
  slug: string;
  title: string;
  featuredImage: {
    node: {
      id: string;
      sourceUrl?: string;
      mediaItemUrl?: string;
    };
  };
  campaignsOptions: {
    link: string;
    text: string;
  };
}

export const GET_TYPE_A_CAMPAIGNS = gql`
  query getTypeACampaigns {
    generalOptions {
      generalOptions {
        homeAds {
          a1BannerSliderCampaigns {
            ... on Campaign {
              id
              title
              slug
              featuredImage {
                node {
                  id
                  mediaItemUrl
                  sourceUrl(size: LARGE)
                }
              }
              campaignsOptions {
                link
                text
              }
            }
          }
        }
      }
    }
  }
`;
